import React from "react";
import PropTypes from "prop-types";
import {Checkbox, Divider, ListItem, ListItemText, ListItemIcon} from "@material-ui/core";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import Collapse from "@material-ui/core/Collapse/Collapse";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RenderDraggableItem from "./RenderDraggableItem";
import {Draggable} from "react-beautiful-dnd";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";

const useStyles = makeStyles(() => ({
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0,
        cursor: 'pointer'
    },
    listItemRoot: {
        minWidth: 24
    }
}));

const RenderColumns = (props) => {
    const {
        sourceColumns, parentIndex, parentName,
        checkBoxChange, expanded, expandColumn
    } = props;
    const classes = useStyles();
    let counter = 0;
    const {userLanguage} = useSelector(state => state.app);
    const Cols = ({sourceColumns, parentIndex, parentName, parentEntity, parentType, checkBoxChange, level = 0}) => {
        return (
            sourceColumns.map((column, index) => {
                counter = counter + 1;
                if(parentEntity) {
                    column.entity = parentEntity;
                    column.parentType = parentType
                }
                const multiLanguageLabel = multiLanguageValue(column.label, userLanguage)
                return (
                    column.properties ? (
                        <React.Fragment key={`${column.name}_${index}`}>
                            <Draggable
                                draggableId={column.name}
                                index={Number(counter)}
                                isDragDisabled={column.dropped}
                            >
                                {(provided, snapshot) => (
                                    <>
                                        <ListItem
                                            disableGutters={true}
                                            classes={{dense: classes.listItemDense}}
                                            onClick={() => expandColumn(column.name)}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <Checkbox checked={column.dropped || false}
                                                      size={"small"}
                                                      value={column.dropped || false}
                                                      onClick={e => e.stopPropagation()}
                                                      onChange={(event) => checkBoxChange(event, column)}
                                                      style={{padding: 0, marginRight: 5}}
                                                      color={"primary"}/>
                                            <ListItemText primary={multiLanguageLabel}/>
                                            <ListItemIcon
                                                classes={{root: classes.listItemRoot}}
                                            >
                                                {expanded[column.name] ? (<ExpandLess/>) : (<ExpandMore/>)}
                                            </ListItemIcon>

                                        </ListItem>
                                        {snapshot.isDragging && (
                                            <ListItem
                                                disableGutters={true}
                                                classes={{dense: classes.listItemDense}}
                                            >
                                                <ListItemText primary={multiLanguageLabel}/>
                                                <ListItemIcon
                                                    classes={{root: classes.listItemRoot}}
                                                >
                                                    {expanded[column.name] ? (<ExpandLess/>) : (<ExpandMore/>)}
                                                </ListItemIcon>
                                            </ListItem>
                                        )}
                                    </>
                                )}
                            </Draggable>

                            <Divider/>
                            <Collapse
                                in={expanded[column.name]}
                            >
                                <Cols
                                    sourceColumns={column.properties}
                                    parentIndex={parentIndex ? `${parentIndex}.${index}` : index}
                                    parentName={parentName ? `${parentName}.${column.name}` : column.name}
                                    parentType={parentType ? parentType : column.type}
                                    parentEntity={column.entity}
                                    checkBoxChange={checkBoxChange}
                                    level={level + 1}
                                />
                            </Collapse>
                        </React.Fragment>
                    ) : (
                        <RenderDraggableItem
                            column={{
                                ...column,
                                name: parentName ? `${parentName}.${column.name}` : column.name
                            }}
                            index={counter}
                            checkBoxChange={checkBoxChange}
                            level={level}
                        />
                    )
                )
            })
        )
    };

    return (
        <Cols
            sourceColumns={sourceColumns}
            checkBoxChange={checkBoxChange}
            parentName={parentName}
            parentIndex={parentIndex}
        />
    )
};

export default RenderColumns

RenderColumns.propTypes = {
    sourceColumns: PropTypes.array,
    parentIndex: PropTypes.number,
    parentName: PropTypes.string,
    checkBoxChange: PropTypes.func,
    expanded: PropTypes.object,
    expandColumn: PropTypes.func
};